module.exports = __webpack_public_path__ + "img/lakeland.055f84a9.png";